const pct = (x) => (x == null ? "—" : `${Math.round(x * 100)}%`);

export function SourceBreakdownTable({ rows, period }) {
  const best = Math.max(0, ...rows.filter((r) => r.new_leads >= 3).map((r) => r.customer_rate || 0));
  return (
    <div data-testid="conversion-by-source">
      <div className="text-2xs uppercase tracking-wider text-zinc-500 mb-1">
        By source · first enquiry channel · last 12 {period === "week" ? "weeks" : "months"}
      </div>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="text-2xs uppercase tracking-wider text-zinc-500 border-b border-zinc-200">
            <tr>
              <th className="text-left py-1.5">Source</th>
              <th className="text-right py-1.5">New leads</th>
              <th className="text-right py-1.5">Reached prospect</th>
              <th className="text-right py-1.5">Became customer</th>
              <th className="text-right py-1.5">Lost</th>
              <th className="text-right py-1.5">Still lead</th>
              <th className="text-right py-1.5">Existing clients</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-zinc-100 font-mono-num">
            {rows.map((r) => {
              const empty = r.new_leads === 0 && r.existing_clients === 0;
              const top = best > 0 && r.new_leads >= 3 && r.customer_rate === best;
              return (
                <tr key={r.source} className={empty ? "text-zinc-300" : ""} data-testid={`source-row-${r.source}`}>
                  <td className="py-1.5 font-sans text-zinc-900">
                    {r.label}
                    {top && (
                      <span className="ml-1.5 text-2xs uppercase tracking-wider px-1 py-0.5 rounded border bg-emerald-50 text-emerald-800 border-emerald-300" data-testid={`source-best-${r.source}`}>
                        best conversion
                      </span>
                    )}
                  </td>
                  <td className="text-right">{r.new_leads}</td>
                  <td className="text-right text-amber-800">{r.reached_prospect} <span className="text-zinc-400">{pct(r.prospect_rate)}</span></td>
                  <td className="text-right text-emerald-700">{r.became_customer} <span className="text-zinc-400">{pct(r.customer_rate)}</span></td>
                  <td className="text-right text-zinc-600">{r.lost}</td>
                  <td className="text-right text-sky-800">{r.still_lead}</td>
                  <td className="text-right text-zinc-500">{r.existing_clients}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
